import { signInAnonymously } from 'firebase/auth';
import { ShiritoriFirebaseAuth } from '../firebase/firebase-app';
import { GetLocalStorage, LocalStorageKeyName, SetLocalStorage } from './local-storage';

export function getDeviceId() {
    return ShiritoriFirebaseAuth.currentUser?.uid || '';
}

export function getPlayerName() {
    return GetLocalStorage(LocalStorageKeyName.PlayerName) || '';
}

export function setPlayerName(playerName: string) {
    SetLocalStorage(LocalStorageKeyName.PlayerName, playerName);
}

export function WaitForAuthEffect() {
    return new Promise<string>((resolve, reject) => {
        const unsubscribe = ShiritoriFirebaseAuth.onAuthStateChanged(async (user) => {
            if (user) {
                console.log('[device-id] User is signed in:', user.uid);

                resolve(user.uid);
            } else {
                console.log('[device-id] No user found. Creating anonymous user');
                try {
                    const credential = await signInAnonymously(ShiritoriFirebaseAuth);
                    const uid = credential.user.uid;

                    SetLocalStorage(LocalStorageKeyName.DeviceId, uid);
                    resolve(uid);
                } catch (error) {
                    console.log('[device-id] Error creating anonymous user:', error);
                    reject();
                }
            }

            unsubscribe();
        });
    });
}